import { Info } from "lucide-react";
import { Link } from "@tanstack/react-router";

type Variant = "kalender" | "prayer" | "hari" | "harpitnas" | "zodiak";

const COPY: Record<Variant, { sources: string; verify: string }> = {
  kalender: {
    sources: "Data libur nasional & cuti bersama: SKB 3 Menteri (Menag, Menaker, Menpan-RB).",
    verify: "Sistem ini berjalan otomatis dan mengikuti SKB resmi. Mohon verifikasi ulang untuk keperluan administratif/HR.",
  },
  prayer: {
    sources: "Jadwal sholat dihitung dengan metode Kementerian Agama RI Bimas Islam (Subuh 20°, Isya 18°, ihtiyat 2 menit) berbasis koordinat lokasi.",
    verify: "Selisih ±1–2 menit antar kecamatan adalah wajar. Untuk ibadah penting, padankan dengan masjid setempat.",
  },
  hari: {
    sources: "Daftar hari penting bersumber dari Keputusan Presiden, kalender PBB/UNESCO, dan kompilasi peringatan nasional.",
    verify: "Beberapa peringatan internasional disesuaikan tanggal lokalnya. Kabari kami jika ada koreksi.",
  },
  harpitnas: {
    sources: "Tanggal harpitnas dihitung otomatis dari kalender libur nasional & cuti bersama (SKB 3 Menteri).",
    verify: "Tanggal merah dapat berubah jika SKB direvisi. Periksa kembali sebelum mengajukan cuti.",
  },
  zodiak: {
    sources: "Rentang zodiak mengikuti standar tropikal yang dipakai lembaga astrologi mainstream.",
    verify: "Konten zodiak bersifat hiburan dan refleksi, bukan ramalan pasti.",
  },
};

export function SourcesNote({ variant = "kalender" }: { variant?: Variant }) {
  const c = COPY[variant];
  return (
    <aside className="mt-8 rounded-lg border border-border bg-muted/30 p-4 text-xs text-muted-foreground">
      <div className="flex items-start gap-2">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" />
        <div className="space-y-1">
          <p><span className="font-semibold text-foreground">Sumber data: </span>{c.sources}</p>
          <p>{c.verify}{" "}
            <Link to={"/kontak/?topic=koreksi" as never} className="text-primary hover:underline">
              Laporkan kesalahan redaksi →
            </Link>
          </p>
        </div>
      </div>
    </aside>
  );
}